import { render, staticRenderFns } from "./SinglePrize_ssdt.vue?vue&type=template&id=21107841&scoped=true&"
import script from "./SinglePrize_ssdt.vue?vue&type=script&lang=js&"
export * from "./SinglePrize_ssdt.vue?vue&type=script&lang=js&"
import style0 from "./SinglePrize_ssdt.vue?vue&type=style&index=0&id=21107841&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21107841",
  null
  
)

export default component.exports